<template>
	<section class="content-wrapper">
		<h3 class="text-center">Unsere Produktreihen</h3>
		<section class="mod_category-teaser">
			<div class="category-teaser" @click="$router.push('/produkte/amecke-sanfte-saefte');">
				<a>
					<img
						:src="$APIURL +'../files/images/categories/Teaser-Kategorie-Sanfte-Saefte.png?v=2023-09-12_1'"
						alt="Sanfte Säfte"
					>
					Sanfte Säfte
					<div class="category-teaser--info">
						<h5 style="color: rgb(231, 144, 41);">Sanfte Säfte</h5>
					</div>
				</a>
			</div>
			<div class="category-teaser" @click="$router.push('/produkte/amecke-sanfte-suesse');">
				<a>
					<img
						:src="$APIURL +'../files/images/categories/Teaser-Kategorie-Sanfte-Suesse.png?v=2023-09-12_1'"
						alt="Sanfte Süße"
					>
					Sanfte SäSüßefte
					<div class="category-teaser--info">
						<h5 style="color: rgb(231, 144, 41);">Sanfte Süße</h5>
					</div>
				</a>
			</div>
			<div class="category-teaser" @click="$router.push('/produkte/amecke-plus');">
				<a>
					<img
						:src="$APIURL +'../files/images/categories/Teaser-Kategorie-Plus-Saefte.png?v=2023-09-12_1'"
						alt="Amecke Plus"
					>
					Amecke Plus
					<div class="category-teaser--info">
						<h5 style="color: rgb(192, 44, 87);">Amecke Plus</h5>
					</div>
				</a>
			</div>
			<div class="category-teaser" @click="$router.push('/produkte/amecke-bio');">
				<a>
					<img :src="$APIURL +'../files/images/categories/Teaser-Kategorie-Bio.png?v=2023-09-12_1'" alt="Amecke Bio">
					Amecke Bio
					<div class="category-teaser--info">
						<h5 style="color: rgb(27, 84, 56);">Amecke Bio</h5>
					</div>
				</a>
			</div>
			<div class="category-teaser" @click="$router.push('/produkte/wilde-wiese');">
				<a>
					<img
						:src="$APIURL +'../files/images/categories/Teaser-Kategorie-Wilde-Wiese.png?v=2023-09-12_1'"
						alt="Wilde Wiese"
					>
					Wilde Wiese
					<div class="category-teaser--info">
						<h5 style="color: rgb(33, 58, 3);">Wilde Wiese</h5>
					</div>
				</a>
			</div>
			<div class="category-teaser" @click="$router.push('/produkte/amecke-mehrweg');">
				<a>
					<img
						:src="$APIURL +'../files/images/categories/Teaser-Kategorie-Mehrweg.png?v=2023-09-12_1'"
						alt="Wilde Wiese"
					>
					Amecke Mehrweg
					<div class="category-teaser--info">
						<h5 style="color: rgb(33, 58, 3);">Amecke Mehrweg</h5>
					</div>
				</a>
			</div>
		</section>
	</section>
</template>
<script>
	import Base from "./Base.vue";
	export default {
		extends: Base,
		props: {
			type: false,
			objectdata: {}
		},

		data() {
			return {};
		},
		created() {
			// this.init();
		},
		methods: {},
		composed: {
			getfullheadline() {
				return;
			}
		}
	};
</script>

<style lang="scss">
</style>